module.exports = __webpack_public_path__ + "img/item.ed58f2ef.png";